"use strict";
import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
    Alpine.data('parent_child', () => ({
        open: false,

        /** Alpine x-model 配列は checkbox value（文字列）と型を揃える */
        normalizeCheckboxValue(value) {
            return String(value);
        },

        childValuesInclude(values, value) {
            const key = this.normalizeCheckboxValue(value);
            return values.some((v) => this.normalizeCheckboxValue(v) === key);
        },

        parent: null,
        active_child_checked: 0,
        total_children: 0,
        total_active_children: [],
        available_checkbox_values: [],
        _initializing: true, // 初期化中フラグ

        // 初期化処理
        init() {
            this.total_children = parseInt(this.$el.dataset.childCount || '0', 10);

            // 子チェックボックスの value 一覧を収集（親チェック時に全選択するため）
            this.collectAvailableCheckboxValues();

            // DOM 上の実際の子数で上書き（data-child-count と不一致の場合の CD 等対策）
            if (this.available_checkbox_values.length > 0) {
                this.total_children = this.available_checkbox_values.length;
            }

            // ページ読み込み時に、既にcheckedされているcheckboxの状態を読み取る
            const checkedValues = this.syncCheckedStateFromDOM();
            if (checkedValues.length > 0) {
                this.total_active_children = checkedValues;

                this.$nextTick(() => {
                    this.ensureCheckboxesAreChecked(checkedValues);
                });
            }

            // Parent checkboxの状態を読み取る
            this.syncParentStateFromDOM();

            // 初期化時にparent checkboxの状態を設定（childrenの状態に基づいて）
            this.updateParentStateFromChildren();

            // Watchを設定（初期化完了後に有効化）
            this.$watch('total_active_children', value => {
                if (!this._initializing) {
                    this.onChildChange(value);
                }
            });
            this.$watch('parent', value => {
                if (!this._initializing) {
                    this.onParentChange(value);
                }
            });

            // 初期化完了
            this.$nextTick(() => {
                this._initializing = false;
                // 初期化完了後、もう一度parent stateを更新して確実にindeterminateが表示される
                this.updateParentStateFromChildren();
            });
        },

        // 子チェックボックスの value 一覧を収集（親チェック時に全選択するため）
        collectAvailableCheckboxValues() {
            const checkboxContainer = this.$el.querySelector('.acordion-checkbox-content');
            if (!checkboxContainer) {
                return;
            }
            const childCheckboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]');
            const values = [];
            childCheckboxes.forEach(checkbox => {
                const value = this.normalizeCheckboxValue(checkbox.value);
                if (value !== '' && !this.childValuesInclude(values, value)) {
                    values.push(value);
                }
            });
            this.available_checkbox_values = values;
        },

        // DOMからcheckedされているcheckboxの状態を読み取ってAlpine.js stateに同期
        syncCheckedStateFromDOM() {
            // このコンポーネント内のすべての子checkboxを取得
            // .acordion-checkbox-content内のcheckboxを探す（子checkboxのコンテナ）
            const checkboxContainer = this.$el.querySelector('.acordion-checkbox-content');
            if (!checkboxContainer) {
                return [];
            }

            const childCheckboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]');
            const checkedValues = [];

            childCheckboxes.forEach(checkbox => {
                // checkboxがcheckedされている場合、そのvalueを配列に追加
                // checked属性またはcheckedプロパティを確認
                if (checkbox.checked || checkbox.hasAttribute('checked')) {
                    const value = this.normalizeCheckboxValue(checkbox.value);
                    if (value !== '' && !this.childValuesInclude(checkedValues, value)) {
                        checkedValues.push(value);
                    }
                }
            });

            return checkedValues;
        },

        // 指定された値のcheckboxが確実にcheckedされていることを確認
        ensureCheckboxesAreChecked(checkedValues) {
            const checkboxContainer = this.$el.querySelector('.acordion-checkbox-content');
            if (!checkboxContainer) {
                return;
            }

            const childCheckboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]');
            childCheckboxes.forEach(checkbox => {
                const value = this.normalizeCheckboxValue(checkbox.value);
                if (value !== '' && this.childValuesInclude(checkedValues, value)) {
                    // checkboxを確実にcheck
                    checkbox.checked = true;
                }
            });
        },

        // DOMからparent checkboxの状態を読み取ってAlpine.js stateに同期
        syncParentStateFromDOM() {
            // parent checkboxを取得（x-ref="parent_el"が設定されているcheckbox）
            const parentCheckbox = this.$refs.parent_el;
            if (!parentCheckbox) {
                return;
            }

            // parent checkboxがcheckedされている場合、parent stateを設定
            if (parentCheckbox.checked || parentCheckbox.hasAttribute('checked')) {
                this.parent = true;

                // Parentがcheckedされている場合、checkedされているchild checkbox valuesを収集
                // もしtotal_active_childrenが空または不完全な場合、すべてのchild valuesを設定
                const checkboxContainer = this.$el.querySelector('.acordion-checkbox-content');
                if (checkboxContainer && (this.total_active_children.length === 0 ||
                    this.total_active_children.length < this.total_children)) {
                    const allChildCheckboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]');
                    const allChildValues = [];
                    allChildCheckboxes.forEach(checkbox => {
                        const value = this.normalizeCheckboxValue(checkbox.value);
                        if (value !== '' && !this.childValuesInclude(allChildValues, value)) {
                            allChildValues.push(value);
                        }
                    });

                    // total_active_childrenをすべてのchild valuesに設定（parentがcheckedならすべてのchildもcheckedとみなす）
                    if (allChildValues.length > 0) {
                        this.total_active_children = allChildValues;
                    }
                }
            } else {
                this.parent = false;
            }
        },

        // Childrenの状態に基づいてparent checkboxの状態を更新
        updateParentStateFromChildren() {
            const parentCheckbox = this.$refs.parent_el;
            if (!parentCheckbox) {
                return;
            }

            const checkedCount = this.total_active_children.length;
            const totalCount = this.total_children;

            // Parent checkboxがDOMでcheckedされている場合は、そのまま維持
            if (parentCheckbox.checked || parentCheckbox.hasAttribute('checked')) {
                // Parentがcheckedされている場合、すべてのchildrenもcheckedとみなす
                if (checkedCount < totalCount && totalCount > 0) {
                    // 実際には一部のchildrenしかcheckedされていない場合、indeterminateに設定
                    parentCheckbox.checked = false;
                    parentCheckbox.indeterminate = true;
                    this.parent = false;
                } else {
                    parentCheckbox.checked = true;
                    parentCheckbox.indeterminate = false;
                    this.parent = true;
                }
            } else {
                // Parentがcheckedされていない場合、childrenの状態に基づいて設定
                if (checkedCount === 0) {
                    // 子がチェックされていない → unchecked状態
                    parentCheckbox.checked = false;
                    parentCheckbox.indeterminate = false;
                    this.parent = false;
                } else if (checkedCount > 0 && checkedCount < totalCount) {
                    // 一部の子がチェックされている → indeterminate状態
                    parentCheckbox.checked = false;
                    parentCheckbox.indeterminate = true;
                    this.parent = false;
                } else if (checkedCount === totalCount && totalCount > 0) {
                    // 全ての子がチェックされている → checked状態
                    parentCheckbox.checked = true;
                    parentCheckbox.indeterminate = false;
                    this.parent = true;
                }
            }
        },

        onChildChange() {
            const parentCheckbox = this.$refs.parent_el;
            if (!parentCheckbox || this.total_children === 0) {
                return;
            }
            if (this.total_active_children.length === 0) {
                this.$refs.parent_el.checked = false;
                this.$refs.parent_el.indeterminate = false;
            } else if (this.total_active_children.length < this.total_children) {
                this.$refs.parent_el.indeterminate = true;
                this.$refs.parent_el.checked = false;
            } else if (this.total_active_children.length >= this.total_children) {
                this.$refs.parent_el.checked = true;
                this.$refs.parent_el.indeterminate = false;
            }
        },

        onParentChange(value) {
            if (value === true) {
                // 子が0個の場合は total_active_children を触らない（onChildChange で uncheck されないように）
                if (this.total_children > 0) {
                    this.total_active_children = this.available_checkbox_values;
                }
            } else {
                this.total_active_children = [];
            }
        }
    }));

    // マルチティアツリー用のコンポーネント（ジャンル検索フィルターなど）
    Alpine.data('category_tree', () => ({
        parent: null,
        total_active_children: 0,
        total_children: 0,
        child_checkbox_values: [],
        _initialized: false,

        // 初期化処理
        init() {
            // 子チェックボックスの数と値を取得
            // this.total_children = parseInt(this.$el.dataset.childCount || '0', 10);
            this.total_children = parseInt(this.$el.querySelectorAll('.acordion-content input[type="checkbox"]').length, 10);

            let total_children_only = parseInt(this.$el.querySelectorAll('.acordion-content .acordion-checkbox-content input[type="checkbox"]').length, 10);


            // 子チェックボックスの値を収集
            this.collectChildValues();

            // 親チェックボックスのHTML属性からの初期状態を読み取る
            const parentCheckbox = this.$refs.parent_el;
            if (parentCheckbox) {
                // HTML要素のchecked属性を尊重してparentの初期値を設定
                this.parent = parentCheckbox.checked;
            }

            // アクティブな子チェックボックスの数を計算（初期化時のみ）
            this.countActiveChildren();

            // 親チェックボックスの初期状態を設定（フォーム送信時のチェック状態を反映）
            if (parentCheckbox && total_children_only > 0) {
                const checkedCount = this.total_active_children;
                const totalCount =total_children_only;

                // 親がHTMLでcheckedの場合: フォームで実際に送信されたのでそのまま維持
                // 親がcheckedでない場合: 子の状態に基づいてindeterminate/uncheckedを設定

                if (!parentCheckbox.checked) {
                    if (checkedCount > 0 && checkedCount < totalCount) {
                        // 一部の子がチェックされている → indeterminate状態
                        parentCheckbox.indeterminate = true;
                        this.parent = false;
                    } else if (checkedCount === totalCount && totalCount > 0) {
                        // 全ての子がチェックされている → checked状態
                        parentCheckbox.checked = true;
                        parentCheckbox.indeterminate = false;
                        this.parent = true;
                    } else {
                        // 子がチェックされていない → unchecked状態
                        parentCheckbox.indeterminate = false;
                        this.parent = false;
                    }
                }
            }

            // 初期化完了フラグを設定
            this._initialized = true;

            // 子チェックボックスの変更を監視
            this.$el.addEventListener('child-checkbox-changed', () => {
                this.updateParentState();
            });

            // 親チェックボックスの変更を監視
            this.$watch('parent', value => this.onParentChange(value));
        },

        // 全ての子孫チェックボックスの値を収集
        collectChildValues() {
            this.child_checkbox_values = [];
            const childCheckboxes = this.$el.querySelectorAll('.acordion-content input[type="checkbox"]');
            childCheckboxes.forEach(checkbox => {
                const value = parseInt(checkbox.value);
                if (!isNaN(value)) {
                    this.child_checkbox_values.push(value);
                }
            });
        },

        // アクティブな子チェックボックスの数をカウント（初期化時に使用）
        countActiveChildren() {
            if (this.total_children === 0) {
                return;
            }

            // 全ての子孫チェックボックスのチェック状態を確認
            const childCheckboxes = this.$el.querySelectorAll('.acordion-content input[type="checkbox"]');
            let checkedCount = 0;

            childCheckboxes.forEach(checkbox => {
                if (checkbox.checked) {
                    checkedCount++;
                }
            });

            this.total_active_children = checkedCount;
        },

        // 親チェックボックスの状態を更新（子チェックボックスの状態に基づく）
        updateParentState() {
            if (this.total_children === 0) {
                return;
            }


            // 全ての子孫チェックボックスのチェック状態を確認
            const childCheckboxes = this.$el.querySelectorAll(':scope > .acordion-content input[type="checkbox"]');
            let checkedCount = 0;
            let totalCount = 0;
            childCheckboxes.forEach(checkbox => {
                totalCount++;
                if (checkbox.checked) {
                    checkedCount++;
                }
            });

            this.total_active_children = checkedCount;

            // 親チェックボックスの参照を取得
            const parentCheckbox = this.$refs.parent_el;
            if (!parentCheckbox) {
                return;
            }

            // 初期化時は親チェックボックスの状態を変更しない（HTML属性を尊重）
            // ユーザー操作時のみ、子の状態に基づいて親を更新する
            if (!this._initialized) {
                return;
            }

            // 親の状態を設定
            if (checkedCount === 0) {
                // 全てチェックされていない
                parentCheckbox.checked = false;
                parentCheckbox.indeterminate = false;
                this.parent = false;
            } else if (checkedCount < totalCount) {
                // 一部チェックされている
                parentCheckbox.indeterminate = true;
                parentCheckbox.checked = false;
                this.parent = false;
            } else {
                // 全てチェックされている
                parentCheckbox.checked = true;
                parentCheckbox.indeterminate = false;
                this.parent = true;
            }
        },

        // 親チェックボックスが変更されたときの処理
        onParentChange(value) {
            if (this.total_children === 0) {
                return;
            }

            // 全ての子孫チェックボックスを取得
            const childCheckboxes = this.$el.querySelectorAll('.acordion-content input[type="checkbox"]');

            childCheckboxes.forEach(checkbox => {
                // 子チェックボックスの状態を親に合わせる
                checkbox.checked = value === true;

                // チェックボックスのchangeイベントを発火させる（フォーム送信用）
                const event = new Event('change', { bubbles: true });
                checkbox.dispatchEvent(event);
            });

            // 子孫コンポーネントにも通知
            const childComponents = this.$el.querySelectorAll('[x-data*="category_tree"]');
            childComponents.forEach(childEl => {
                if (childEl !== this.$el) {
                    const childCheckbox = childEl.querySelector(':scope > .checkbox-group input[type="checkbox"]');
                    if (childCheckbox) {
                        childCheckbox.checked = value === true;
                        const event = new Event('change', { bubbles: true });
                        childCheckbox.dispatchEvent(event);
                    }
                }
            });

            // 親の状態を更新
            this.updateParentState();
        },

        // 子チェックボックスが変更されたことを親に通知
        notifyParentOfChange() {
            this.$el.dispatchEvent(new CustomEvent('child-checkbox-changed', {
                bubbles: true
            }));
        }
    }));

    const FILTER_REPLAY_FORM_IDS = [
        'eccube-used-genre-filter-clear-replay-form',
        'eccube-used-new-release-filter-clear-replay-form',
        'eccube-product-filter-clear-replay-form',
        'eccube-store-inventory-filter-clear-replay-form',
    ];

    // 並び替えと表示件数を制御するコンポーネント
    Alpine.data('sortAndDisplayControl', () => ({
        currentOrderBy: null,
        currentDispNumber: null,
        formElement: null,

        // 初期化処理
        init() {
            // DOMが完全に読み込まれた後にフォーム要素を取得
            this.initializeForm();
            this.$nextTick(() => this.syncOrderByDisplayLabel());
        },

        // フォーム要素の初期化（遅延実行対応）
        initializeForm(retryCount = 0) {
            // まずURLパラメータから値を取得（フォームがなくても動作するため）
            this.initializeFromUrlParams();

            // フォーム要素を取得
            this.formElement = document.querySelector('#sub-genre-filter-window form');

            if (!this.formElement) {
                if (document.querySelector('#detailed-product-search')) {
                    this.formElement = document.querySelector('#maniac-search-area form');
                }
            }

            if (!this.formElement) {
                for (const formId of FILTER_REPLAY_FORM_IDS) {
                    this.formElement = document.getElementById(formId);
                    if (this.formElement) {
                        break;
                    }
                }
            }

            if (!this.formElement) {
                // sub-genre-filter-window は AJAX 遅延のため長めにリトライ（30回 × 100ms）
                if (retryCount < 10) {
                    setTimeout(() => this.initializeForm(retryCount + 1), 100);
                    return;
                }
                this.normalizeDispNumberState();
                this.syncOrderByDisplayLabel();
                return;
            }

            // 隠しフィールドから現在の値を取得（URL の orderby または nors 復元時）
            const orderByField = this.formElement.querySelector('[name*="[orderby]"]');
            const dispNumberField = this.formElement.querySelector('[name*="[disp_number]"]');

            if (this.hasExplicitOrderByInUrl() && orderByField && orderByField.value) {
                this.currentOrderBy = parseInt(orderByField.value, 10);
            }
            if (dispNumberField && dispNumberField.value) {
                this.currentDispNumber = parseInt(dispNumberField.value, 10);
            }

            this.normalizeDispNumberState();
            this.syncOrderByDisplayLabel();
        },

        // URL に orderby があるか
        hasExplicitOrderByInUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            const formNames = ['base_product_stock_search', 'base_search', 'search_detailed_product_search'];
            if (urlParams.get('orderby')) {
                return true;
            }
            for (const name of formNames) {
                if (urlParams.get(`${name}[orderby]`)) {
                    return true;
                }
            }
            return false;
        },

        // 並び替えラベルに選択肢名を出すべきか（URL に orderby があるときのみ）
        hasActiveOrderByContext() {
            return this.$el.dataset.showSelectedOrderBy === '1' || this.hasExplicitOrderByInUrl();
        },

        // ドロップダウン内リンクのテキストからラベルを取得（data-order-by 優先、在庫検索など ID が飛び番のメニューに対応）
        getOrderByLabelFromDom(orderById) {
            const links = this.$el.querySelectorAll('.filter-order-val-area a');
            const id = Number(orderById);
            if (Number.isNaN(id)) {
                return null;
            }
            for (const link of links) {
                if (link.dataset.orderBy !== undefined && parseInt(link.dataset.orderBy, 10) === id) {
                    return link.textContent.trim();
                }
            }
            const link = links[id - 1];
            return link ? link.textContent.trim() : null;
        },

        // 並び替えラベルを画面上に反映
        syncOrderByDisplayLabel() {
            const labelEl = this.$el.querySelector('.filter-order-form-label');
            if (!labelEl) {
                return;
            }
            if (!this.hasActiveOrderByContext()) {
                labelEl.textContent = '並び替え';
                return;
            }
            const fallback = this.$el.dataset.initialOrderByLabel || '並び替え';
            let id = this.currentOrderBy;
            if (id === null || id === undefined || Number.isNaN(Number(id))) {
                const orderByField = this.formElement
                    ? this.formElement.querySelector('[name*="[orderby]"]')
                    : null;
                if (orderByField && orderByField.value) {
                    id = parseInt(orderByField.value, 10);
                    if (!Number.isNaN(id)) {
                        this.currentOrderBy = id;
                    }
                }
            }
            if (id === null || id === undefined || Number.isNaN(Number(id))) {
                labelEl.textContent = fallback;
                return;
            }
            labelEl.textContent = this.getOrderByLabelFromDom(id) || fallback;
        },

        // URL/フォームどちらも無い・遅延で form 未取得のとき、data-initial-disp-number または 20 で表示件数ハイライトを揃える
        normalizeDispNumberState() {
            const v = this.currentDispNumber;
            const invalid = v === null || v === undefined || Number.isNaN(Number(v));
            if (!invalid) {
                return;
            }
            const raw = this.$el && this.$el.dataset ? this.$el.dataset.initialDispNumber : '';
            if (raw !== undefined && raw !== '') {
                const n = parseInt(raw, 10);
                if (!Number.isNaN(n)) {
                    this.currentDispNumber = n;

                    return;
                }
            }
            this.currentDispNumber = 20;
        },

        // URLパラメータから初期値を取得
        initializeFromUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);

            // 全てのフォーム名をチェック
            const formNames = ['base_product_stock_search', 'base_search', 'search_detailed_product_search'];
            let orderByParam = urlParams.get('orderby');
            let dispNumberParam = urlParams.get('disp_number');

            for (const name of formNames) {
                if (!orderByParam) {
                    orderByParam = urlParams.get(`${name}[orderby]`);
                }
                if (!dispNumberParam) {
                    dispNumberParam = urlParams.get(`${name}[disp_number]`);
                }
            }

            if (orderByParam) {
                this.currentOrderBy = parseInt(orderByParam);
            }
            if (dispNumberParam) {
                this.currentDispNumber = parseInt(dispNumberParam);
            }
        },

        // 並び替えを変更（GET リダイレクトで URL に orderby を残し、ラベル復元と整合）
        changeOrderBy(value) {
            this.currentOrderBy = value;
            const labelEl = this.$el.querySelector('.filter-order-form-label');
            if (labelEl) {
                labelEl.textContent = this.getOrderByLabelFromDom(value) || '並び替え';
            }
            this.redirectWithParam('orderby', value);
        },

        // 表示件数を変更（GET フォーム丸ごと送信を避け、orderby が URL に混入しないよう redirectWithParam を使用）
        changeDispNumber(value) {
            this.currentDispNumber = value;
            this.redirectWithParam('disp_number', value);
        },

        // 隠しフィールドを更新してフォームを送信
        updateHiddenFieldAndSubmit(fieldName, value) {
            // フォームがない場合はURLパラメータで直接リダイレクト
            if (!this.formElement) {
                this.redirectWithParam(fieldName, value);
                return;
            }

            // 隠しフィールドを探して更新
            const hiddenField = this.formElement.querySelector(`[name*="[${fieldName}]"]`);

            if (hiddenField) {
                hiddenField.value = value;

                // フォームを送信
                this.formElement.submit();
            } else {
                console.error(`${fieldName}フィールドが見つかりません`);
                // フィールドがない場合もURLパラメータでリダイレクト
                this.redirectWithParam(fieldName, value);
            }
        },

        // URLパラメータを更新してリダイレクト
        redirectWithParam(fieldName, value) {
            const url = new URL(window.location.href);
            const searchStr = window.location.search;

            // URLから既存のフォーム名を検出（最初に見つかったものを使用）
            const formNames = ['base_product_stock_search', 'base_search', 'search_detailed_product_search'];

            // デフォルトはページのdata-default-form-nameから取得、なければbase_search
            const defaultFormNameEl = document.querySelector('[data-default-form-name]');
            let formName = defaultFormNameEl ? defaultFormNameEl.dataset.defaultFormName : 'base_search';

            // URLに既存のフォーム名があればそれを使用
            for (const name of formNames) {
                if (searchStr.includes(name + '[')) {
                    formName = name;
                    break;
                }
            }

            // 他のフォーム名の同じフィールドを削除（重複防止）
            for (const name of formNames) {
                if (name !== formName) {
                    url.searchParams.delete(`${name}[${fieldName}]`);
                }
            }

            const paramName = `${formName}[${fieldName}]`;
            url.searchParams.set(paramName, value);
            // 現在 URL に nors があるときだけ維持する（POST→?nors=1 後の並び替え・件数変更）。
            // 全てクリア後は pathname のみ（nors 無し）なので付与しない。
            // 付与すると session 空 + nors=1 になり「検索条件の有効期限が切れました」誤表示になる（#43433）。
            const nors = url.searchParams.get('nors');
            if (nors) {
                url.searchParams.set('nors', '1');
            }
            // pageno をリセット
            url.searchParams.delete(`${formName}[pageno]`);
            url.searchParams.delete('pageno');
            window.location.href = url.toString();
        },

        // 現在の並び替えかどうかをチェック
        isCurrentOrderBy(value) {
            return this.currentOrderBy === value;
        },

        // 現在の表示件数かどうかをチェック
        isCurrentDispNumber(value) {
            return this.currentDispNumber === value;
        }
    }));

    Alpine.data('autoSuggest', () => ({
        query: '',
        results: {
            artists: [],
            titles: [],
            labels: []
        },
        isLoading: false,
        showSuggestions: false,
        debounceTimeout: null, // デバウンス用のタイムアウトID

        init() {
            // サジェスチョンエリアを常に表示
            this.showSuggestions = true;

            // クエリの変更を監視
            this.$watch('query', (value) => {
                // IME変換中の入力やサジェスト選択によるプログラム的な代入はネイティブの
                if (value.length > 100) {
                    this.query = value.slice(0, 100);
                    return;
                }

                // 既存のタイムアウトをクリア
                if (this.debounceTimeout) {
                    clearTimeout(this.debounceTimeout);
                }

                if (value.length >= 1) {
                    // 0.5秒の遅延を追加してAPI呼び出しを制限
                    this.debounceTimeout = setTimeout(() => {
                        this.fetchSuggestions();
                    }, 500);
                } else {
                    this.results = { artists: [], titles: [], labels: [] };
                    // サジェスチョンエリアは常に表示したままにする
                }
            });
        },

        fetchSuggestions() {
            this.isLoading = true;

            fetch(`/api/internal/open/auto-suggest/search?q=${encodeURIComponent(this.query)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.results = data;
                    // サジェスチョンエリアは常に表示
                    this.showSuggestions = true;
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error('Error fetching suggestions:', error);
                    this.isLoading = false;
                });
        },

        // クリックされたサジェスチョンを選択する
        // アーティスト/レーベルは ID 指定の一覧ページへ、タイトル（商品）は商品詳細ページへ遷移する。
        // それ以外はキーワード検索を実行する
        selectSuggestion(suggestion, type) {
            // アーティスト/レーベルは、キーワード検索ではなく ID 指定の一覧ルートへ遷移する
            if (type === 'artist' && suggestion && suggestion.id != null) {
                window.location.href = `/artist/${encodeURIComponent(suggestion.id)}`;
                return;
            }
            if (type === 'label' && suggestion && suggestion.id != null) {
                window.location.href = `/label/${encodeURIComponent(suggestion.id)}`;
                return;
            }
            // タイトルは、キーワード検索ではなく商品コード指定で商品詳細ページへ遷移する
            if (type === 'title' && suggestion && suggestion.code) {
                window.location.href = `/detail/${encodeURIComponent(suggestion.code)}`;
                return;
            }

            // それ以外（商品コード未取得のフェイルセーフ等）は従来どおりキーワード検索フォームを送信する
            let suggestionText = (suggestion && typeof suggestion === 'object') ? suggestion.name : suggestion;
            // タイトルサジェストをキーワード検索として実行する場合は、ユーザーが明示的に選んだ
            // 「そのタイトル」を商品名のみを対象にフレーズ（完全一致寄り）で検索するため、
            // title: スコープを付与しダブルクォートで囲む（例: title:"タイトル名"）。
            // これにより、アーティスト名の語一致で別商品が上位に混ざる問題を避ける。
            // ただし title: 付きの文字列は入力欄には出さず、送信データだけを差し替える（後述）。
            let scopedText = null;
            if (type === 'title') {
                // 入力欄にはタイトルのみ（引用符・空白を整えた素の文字列）を表示する
                suggestionText = this.cleanSuggestionText(suggestionText);
                scopedText = suggestionText === '' ? '' : `title:"${suggestionText}"`;
            }
            // 入力フィールドに選択されたテキストを設定
            this.query = suggestionText;
            var form = document.querySelector('#autosuggest-form .search-form');
            // フォームを送信
            Alpine.nextTick(() => {
                if (form) {
                    this.submitFormWithScopedKeyword(form, scopedText);
                }
            });
        },

        /**
         * キーワード検索フォームを送信する。title: スコープ指定がある場合は、
         * 入力欄の表示（タイトルのみ）を保ったまま送信データのみを title:"..." に差し替える。
         *
         * @param {HTMLFormElement} form 送信対象フォーム
         * @param {?string} scopedText 送信したいキーワード（title: 付き）。null なら通常送信
         */
        submitFormWithScopedKeyword(form, scopedText) {
            const fieldName = scopedText === null ? null : this.getKeywordFieldName(form);

            // formdata 非対応環境・フィールド名不明時は、従来どおり入力欄経由で送信して
            // スコープ指定が失われないことを優先する（一瞬の表示は許容）。
            if (fieldName === null || typeof window.FormDataEvent !== 'function') {
                if (scopedText !== null) {
                    this.query = scopedText;
                    Alpine.nextTick(() => this.submitForm(form));

                    return;
                }

                this.submitForm(form);

                return;
            }

            const handler = (event) => {
                event.formData.set(fieldName, scopedText);
            };
            form.addEventListener('formdata', handler, { once: true });
            this.submitForm(form);
            // 送信データ構築は submit() 内で同期的に行われるため、この時点で発火済み。
            // 送信されなかった場合にリスナーが残り、次回送信へ紛れ込むのを防ぐ。
            form.removeEventListener('formdata', handler);
        },

        /**
         * フォーム内のキーワード入力欄の name を返す（例: base_search[keyword_search]）。
         *
         * @param {HTMLFormElement} form 送信対象フォーム
         * @returns {?string} name 属性。特定できない場合は null
         */
        getKeywordFieldName(form) {
            const input = form.querySelector('input[name$="[keyword_search]"]')
                || form.querySelector('input[x-model="query"]');

            return (input && input.name) ? input.name : null;
        },

        /**
         * サジェスト文字列をフレーズ検索・入力欄表示に使える形へ整える。
         *
         * バックエンド (KeywordQueryParser) は "..." をフレーズとして扱い、内部に残った
         * ダブルクォートはフレーズを途中で閉じてしまうため、半角/全角のダブルクォートは
         * 除去する。あわせて連続空白（全角スペース含む）を寄せ、前後の空白を落とす。
         *
         * @param {string} text サジェスト文字列
         * @returns {string} 整形後の文字列（空になった場合は空文字）
         */
        cleanSuggestionText(text) {
            return String(text ?? '')
                .replace(/["“”]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        },

        submitForm(form) {
            form.submit();
        }
    }));

    /**
     * Detailed search release date: when unchecked, clear and disable selects.
     * When checked again, restores savedSelectValues (initial HTML or last state before uncheck).
     * Markup: .release-date-container; lazy load uses Alpine.initTree.
     */
    Alpine.data('releaseDateRange', () => ({
        /** @type {HTMLInputElement|null} */
        checkbox: null,
        /** @type {HTMLElement|null} */
        fromGroup: null,
        /** @type {HTMLElement|null} */
        toGroup: null,
        /** @type {HTMLSelectElement[]} */
        selects: [],
        /** @type {string[]} Six select values from initial HTML or snapshot taken before uncheck */
        savedSelectValues: [],

        init() {
            this.cacheRefs();
            if (!this.checkbox || !this.fromGroup || !this.toGroup || this.selects.length === 0) {
                return;
            }

            this.savedSelectValues = this.readSelectValues();

            this.checkbox.addEventListener('change', () => this.handleCheckboxChange());

            this.syncDisabled();
            if (!this.checkbox.checked) {
                this.clearSelects();
                this.refreshDayOptions();
            }
        },

        cacheRefs() {
            const root = this.$el;
            this.checkbox = root.querySelector('.use-release-date-contena input[type="checkbox"]');
            this.fromGroup = root.querySelector('.from-date');
            this.toGroup = root.querySelector('.to-date');
            this.selects = Array.from(root.querySelectorAll('.release-date-input-area select'));
        },

        readSelectValues() {
            return this.selects.map((sel) => sel.value);
        },

        applySelectValues(values) {
            if (!values || values.length !== this.selects.length) {
                return;
            }
            this.selects.forEach((sel, i) => {
                sel.value = values[i] ?? '';
            });
        },

        syncDisabled() {
            const on = this.checkbox.checked;
            this.selects.forEach((sel) => {
                sel.disabled = !on;
            });
        },

        clearSelects() {
            this.selects.forEach((sel) => {
                sel.value = '';
            });
        },

        refreshDayOptions() {
            [this.fromGroup, this.toGroup].forEach((group) => {
                const yearSel = group.querySelector('select');
                if (yearSel) {
                    yearSel.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        },

        handleCheckboxChange() {
            if (!this.checkbox.checked) {
                this.savedSelectValues = this.readSelectValues();
                this.clearSelects();
                this.refreshDayOptions();
                this.syncDisabled();
            } else {
                this.syncDisabled();
                this.applySelectValues(this.savedSelectValues);
                this.refreshDayOptions();
            }
        }
    }));
});

document.addEventListener('detailed-search-form-loaded', () => {
    const root = document.getElementById('detailed-product-search-form');
    if (root) {
        Alpine.initTree(root);
    }
});

